import React from 'react';
import { Form } from 'react-bootstrap';
import QuestionText from './QuestionText';
// import GenericDownloadUploadItems from 'components/DownloadUploadView/GenericDownloadUploadView';
import TooltipComponent from './TooltipComponent';
import GenericDownloadUploadItems from '../GenericDownloadUploadView';
const InputRadio = ({
  question,
  handleAssessmentChange,
  handleChecked,
  isPremium,
  translations,
  assessment,
  areInputsDisabled, // Default to false if not provided
  isMonitoring,
}) => {
  return (
    <QuestionText question={question}>
      <div key={`default-radio-${question.id}`} className='mb-3'>
        {question.answers.map((answer) => (
          <div key={answer.id} className='d-flex align-items-center mb-3 row'>
            <div className='col d-flex align-items-center'>
              <Form.Check
                type='radio'
                // key={answer.id}
                id={`${answer.id}`}
                name={`${question.id}`}
                label={answer.text}
                className='specificyColor'
                onChange={(e) => handleAssessmentChange(e, question.id, answer.id, question.type)}
                checked={handleChecked(question.id, answer.id)}
                disabled={isPremium || areInputsDisabled}
              />
              {answer.description ? <TooltipComponent data={answer.description} /> : null}
              <div className='ml-5'>
                {answer.requiresDocument === 1 && answer.text !== 'No'
                  ? assessment
                      .filter((el) => el.answers?.[0]?.answerId === answer.id)
                      .map((el) =>
                        el.answers?.[0]?.value === 'on' ? (
                          <p
                            style={{ fontSize: '1rem' }}
                            key={`${el.answers?.[0]?.answerId}${el.answers?.[0]?.value}`}
                            className='m-0'>
                            {translations
                              .filter((trans) => trans.code === 'INFOATTACH')
                              .map((trans) => trans.description)}
                          </p>
                        ) : null,
                      )
                  : null}
              </div>
            </div>
            {/* TODO: Qui va messa la logica di visualizzazione o meno della sezione allegati */}
            {isMonitoring && answer.requiresDocument === 1 && answer.text !== 'No'
              ? assessment
                  .filter((el) => el.answers?.[0]?.answerId === answer.id)
                  .map((el) =>
                    el.answers?.[0]?.value === 'on' ? (
                      <div className='col'>
                        <GenericDownloadUploadItems
                          title={'Allegato'}
                          disabled={!handleChecked(question.id, answer.id) || isPremium}
                          corporatequestionnaireId={question?.corporatequestionnaireId || null}
                          answerId={answer.id}
                        />
                      </div>
                    ) : null,
                  )
              : null}
          </div>
        ))}
      </div>
    </QuestionText>
  );
};

export default InputRadio;
